'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'grin-alt';
var width = 496;
var height = 512;
var ligatures = [];
var unicode = 'f581';
var svgPathData = ['M248,8C111,8,0,119,0,256S111,504,248,504,496,393,496,256,385,8,248,8Zm63.7,128.7a19.76,19.76,0,0,1,32.7,0c12.4,18.4,15.1,36.9,15.7,55.3-.5,18.4-3.3,36.9-15.7,55.3a19.76,19.76,0,0,1-32.7,0c-12.4-18.4-15.1-36.9-15.7-55.3C296.5,173.6,299.3,155.1,311.7,136.7Zm-160,0a19.76,19.76,0,0,1,32.7,0c12.4,18.4,15.1,36.9,15.7,55.3-.5,18.4-3.3,36.9-15.7,55.3a19.76,19.76,0,0,1-32.7,0c-12.4-18.4-15.1-36.9-15.7-55.3C136.5,173.6,139.3,155.1,151.7,136.7Zm240.1,202c-9.3,55-83.2,93.3-143.8,93.3s-134.5-38.3-143.8-93.3a16,16,0,0,1,20.7-17.9C155.1,330.5,200,336,248,336s92.9-5.5,123.1-15.2a16,16,0,0,1,20.7,17.9Z', 'M151.7,136.7c-12.4,18.4-15.2,36.9-15.7,55.3.6,18.4,3.3,36.9,15.7,55.3a19.76,19.76,0,0,0,32.7,0c12.4-18.4,15.2-36.9,15.7-55.3-.6-18.4-3.3-36.9-15.7-55.3a19.76,19.76,0,0,0-32.7,0Zm192.7,0a19.76,19.76,0,0,0-32.7,0c-12.4,18.4-15.2,36.9-15.7,55.3.6,18.4,3.3,36.9,15.7,55.3a19.76,19.76,0,0,0,32.7,0c12.4-18.4,15.2-36.9,15.7-55.3C359.5,173.6,356.8,155.1,344.4,136.7Z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faGrinAlt = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;